import React from 'react';
import PropTypes from 'prop-types';
import { CaretLeft, MagnifyingGlass } from '@phosphor-icons/react';
import Input from '../input/input';
import './style';

const SearchOverlay = ({
  top,
  width,
  showOverlay,
  handleBack,
  searchRef,
  inputRef,
  value,
  placeholder,
  handleSearchChange,
  renderSearchList,
}) => {
  return (
    <div
      className={`search-container absolute left-0 ${showOverlay ? 'show' : ''}`}
      style={{ top }}
    >
      {window.innerWidth < 650 && (
        <div
          className="inline-flex justify-center items-center self-baseline p-2 rounded-3xl bg-grey-10"
          onClick={handleBack}
        >
          <CaretLeft size={16} />
        </div>
      )}
      <div className="flex flex-col gap-5"
        ref={searchRef}
        style={{ width }}>
        <Input
          width="100%"
          ref={inputRef}
          value={value}
          placeholder={placeholder}
          iconLeft={<MagnifyingGlass size={24} />}
          onChange={handleSearchChange}
        />
        <div className="flex flex-col gap-2 ">
          <p className="text-grey-70 label-16 px-0">
            {value === '' && 'Trending searches 🔥'}
          </p>
          {renderSearchList()}
        </div>
      </div>
    </div>
  );
};

SearchOverlay.propTypes = {
  showOverlay: PropTypes.bool.isRequired,
  handleBack: PropTypes.func.isRequired,
  searchRef: PropTypes.object.isRequired,
  inputRef: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  renderSearchList: PropTypes.func.isRequired,
};

export default SearchOverlay;
